import { FormPassword, FormTextBox, IDynamicFormRow } from '@src/components';

type LoginSchemaProps = {
    t: (key: string, options?: Record<string, any>) => string;
};

export function loginSchema({ t }: LoginSchemaProps): IDynamicFormRow[] {
    return [
        {
            label: '',
            keyName: 'email',
            inputProperties: {
                placeholder: 'Email',
                type: 'email',
            },
            Component: FormTextBox,
            className: 'h-12',
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.email'),
                    }),
                },
            },
        },
        {
            label: '',
            keyName: 'password',
            inputProperties: {
                placeholder: 'Password',
            },
            Component: FormPassword,
            className: 'h-12',
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.password'),
                    }),
                },
            },
        },
    ];
}
